import { render, staticRenderFns } from "./Erosion.vue?vue&type=template&id=da5b5170&scoped=true&"
import script from "./Erosion.vue?vue&type=script&lang=js&"
export * from "./Erosion.vue?vue&type=script&lang=js&"
import style0 from "./Erosion.vue?vue&type=style&index=0&id=da5b5170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5b5170",
  null
  
)

export default component.exports